<template>
  <div class="sky-hc-software-list sky-hc-software-list__no-border">
    <pagination-table
      ref="multipleTable"
      :data="softwareList"
      :limit="limit"
      :total="count"
      :hasSearch="true"
      :page="page"
      :searchPlaceholder="$t('software.softwareListSeach')"
      @search="handleSearchContent"
      @prevClick="handlePrevClick"
      @nextClick="handleNextClick"
      @sizeChange="handleSizeChange"
    >
     <template slot="btns">
        <el-select v-model="softwareType" @change="handleTypeChange">
          <el-option
            v-for="item in softwareTypeOptions"
            :key="item.CODE"
            :label="item.TXT"
            :value="item.CODE">
          </el-option>
        </el-select>
      </template>
      <template slot="columns">
        <el-table-column prop="name" :label="$t('software.softwareName')"></el-table-column>
        <el-table-column prop="createTime" :label="$t('software.softwareType')" width="260">
          <template slot-scope="scope">
            {{ getSoftwareTypeDesc(scope.row.type) }}
          </template>
        </el-table-column>
        <el-table-column prop="firstCreateTime" :label="$t('software.firstCreateTime')" width="260">
          <template slot-scope="scope">
            {{ scope.row.firstCreateTime ? date.format(scope.row.firstCreateTime, 'yyyy-MM-dd HH:mm:ss') : '' }}
          </template></el-table-column>
        <el-table-column prop="count" :label="$t('software.md5')" width="160"></el-table-column>
      </template>
    </pagination-table>
  </div>
</template>
<script>
import { TableColumn, Input, Select, Option } from 'element-ui'

import date from 'element-ui/lib/utils/date'


import { getSoftwareList } from '@/api/terminal'
import PaginationTable from '@/components/paginationTable'
import {getEnumText} from '@/utils'
import { SOFTEWARE_TYPE } from '@/utils/enum'

export default {
  name: 'ContentAnalysis',
  components: {
    PaginationTable,
    [TableColumn.name]: TableColumn,
    [Select.name]: Select,
    [Option.name]: Option,
    [Input.name]: Input
  },
  data() {
    return {
      limit: 20,
      count: 0,
      page: 0,
      keyword: '',
      softwareList: [],
      date,
      softwareType: SOFTEWARE_TYPE.SOFT.CODE,
      softwareTypeOptions: Object.values(SOFTEWARE_TYPE)
    }
  },
  created() {
    this.handleGetSoftwareList()
  },
  methods: {
    handleSearchContent(keyword) {
      this.keyword = keyword
      this.handleGetSoftwareList()
    },
    handlePrevClick() {
      this.page--
      this.handleGetSoftwareList()
    },
    handleNextClick() {
      this.page++
      this.handleGetSoftwareList()
    },
    handleSizeChange(num) {
      this.limit = num
      this.page = 0
      this.handleGetSoftwareList()
    },
    handleGetSoftwareList() {
      getSoftwareList({
        page: this.page,
        limit: this.limit,
        searchKeyword: this.keyword,
        type: this.softwareType
      }).then(response => {
        this.softwareList = response.data.content.itemArr
        this.count = response.data.content.total
      })
    },
    getSoftwareTypeDesc(type) {
      return getEnumText(SOFTEWARE_TYPE, type, type)
    },
    // 软件类型变更处理
    handleTypeChange() {
      this.page = 0
      this.handleGetSoftwareList()
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(hc-software-list) {
  width: 100%;
  padding-top: 30px;
  padding-bottom: 30px;
}
</style>
